import { z } from 'zod';

import {
  type GetPlatformSystemBillingCatalogResponse,
  type GetPlatformSystemCompanyDetailRequest,
  type GetPlatformSystemCompanyDetailResponse,
  type GetPlatformSystemCompanyDeploymentModeImpactRequest,
  type GetPlatformSystemCompanyDeploymentModeImpactResponse,
  type ActivatePlatformSystemMaterialBody,
  type ActivatePlatformSystemMaterialRequest,
  type ActivatePlatformSystemMaterialResponse,
  type PreviewPlatformSystemCompanyReceiverDirectoryScopeRequest,
  type PreviewPlatformSystemCompanyReceiverDirectoryScopeResponse,
  type AddPlatformPermissionGrantRequest,
  type AssignablePlatformPermission,
  type ListAssignablePlatformGrantPermissionsResponse,
  type GetPlatformSystemCompanyStationDetailRequest,
  type GetPlatformSystemCompanyStationDetailResponse,
  type GetPlatformSystemMaterialDetailRequest,
  type GetPlatformSystemMaterialDetailResponse,
  type GetPlatformSystemMaterialDraftRequest,
  type GetPlatformSystemMaterialDraftResponse,
  type ListPlatformAuditLogsRequest,
  type ListPlatformAuditLogsResponse,
  type ListPlatformPermissionGrantsRequest,
  type ListPlatformPermissionGrantsResponse,
  type ListPlatformSystemCompaniesRequest,
  type ListPlatformSystemCompaniesResponse,
  type ListPlatformSystemCompanyAuditLogsRequest,
  type ListPlatformSystemCompanyAuditLogsResponse,
  type ListPlatformSystemCompanyStationsRequest,
  type ListPlatformSystemCompanyStationsResponse,
  type ListPlatformSystemFeatureAffectedCompaniesRequest,
  type ListPlatformSystemFeatureAffectedCompaniesResponse,
  type ListPlatformSystemMaterialDraftsRequest,
  type ListPlatformSystemMaterialDraftsResponse,
  type ListPlatformSystemMaterialsRequest,
  type ListPlatformSystemMaterialsResponse,
  type ListPlatformSystemPlanAffectedCompaniesRequest,
  type ListPlatformSystemPlanAffectedCompaniesResponse,
  type MutatePlatformSystemMaterialRateResponse,
  type MutatePlatformSystemPlanFeatureMappingBody,
  type MutatePlatformSystemPlanFeatureMappingRequest,
  type MutatePlatformSystemPlanFeatureMappingResponse,
  type PlatformSystemMaterialDraftPublicationResult,
  type PlatformSystemCompanyDetail,
  type PlatformSystemDeploymentModeImpactCloudFacts,
  type PlatformSystemDeploymentModeImpactCounts,
  type PlatformSystemDeploymentModeImpactDiagnostics,
  type PlatformSystemDeploymentModeImpactPreview,
  type PlatformSystemDeploymentModeImpactUnknownLocalFact,
  type PlatformSystemReceiverDirectoryCurrentScope,
  type PlatformSystemReceiverDirectoryScopeCloudFacts,
  type PlatformSystemReceiverDirectoryScopeDiagnostics,
  type PlatformSystemReceiverDirectoryScopeImpactCounts,
  type PlatformSystemReceiverDirectoryScopePreview,
  type PlatformSystemReceiverDirectoryScopeUnknownLocalFact,
  type PlatformSystemReceiverDirectoryTargetScope,
  type PlatformSystemCompanyStationContext,
  type PlatformSystemCompanyStationDetail,
  type PlatformSystemCompanyStationDiagnostics,
  type PlatformSystemCompanyStationListItem,
  type PlatformSystemCompanyAuditLogCompanyContext,
  type PlatformSystemCompanyAuditLogDiagnostics,
  type PlatformSystemCompanyAuditLogItem,
  type PlatformSystemCompanyMembershipSummary,
  type PlatformSystemCompanySummary,
  type PlatformSystemCompanyTopologySummary,
  type PlatformSystemStationAssignmentSummary,
  type PlatformSystemStationDataAvailabilityRow,
  type PlatformSystemStationDeviceClaimDiagnostics,
  type PlatformSystemStationDeviceClaimSummary,
  type PlatformSystemStationReadinessDiagnostics,
  type PlatformSystemStationReadinessParticipant,
  type PlatformSystemStationReadinessParticipantDiagnostics,
  type PlatformSystemStationReadinessReportDetail,
  type PlatformSystemStationReadinessReportSummary,
  type PlatformSystemStationSupportDiagnosticRow,
  type PlatformAuditLogDiagnostics,
  type PlatformAuditLogItem,
  type PlatformAuditLogMetadataSummaryEntry,
  type PlatformPermissionGrantDiagnostics,
  type PlatformPermissionGrantMutationSummary,
  type PlatformPermissionGrantSummary,
  type PlatformPermissionGrantUserItem,
  platformSystemStationClaimStatusFilterValues,
  platformSystemStationDataAvailabilityStatusValues,
  platformSystemCompanyAuditActionValues,
  type MutatePlatformPermissionGrantResponse,
  type PlatformSystemFeatureSummary,
  platformSystemMaterialActivationReadinessSeverityValues,
  platformSystemMaterialActivationReadinessStatusValues,
  platformSystemMaterialActivationStateValues,
  type PlatformSystemMaterialActivationReadinessIssue,
  type PlatformSystemMaterialActivationResult,
  platformSystemMaterialDoriisOfficialSystemValues,
  type PlatformSystemMaterialDoriisMapping,
  platformSystemMaterialEffectiveStateValues,
  platformSystemMaterialGovernanceNoteSeverityValues,
  platformSystemMaterialRateEffectiveStateValues,
  platformSystemMaterialRateMutationKindValues,
  type PlatformSystemMaterialDetail,
  type PlatformSystemMaterialDiagnostics,
  type PlatformSystemMaterialDraftDetail,
  type PlatformSystemMaterialDraftDiagnostics,
  type PlatformSystemMaterialDraftInitialRate,
  type PlatformSystemMaterialDraftReadinessIssue,
  type PlatformSystemMaterialDraftSummary,
  type PlatformSystemMaterialGovernanceNote,
  type PlatformSystemMaterialPresentationFact,
  type PlatformSystemMaterialRateChangeFields,
  type PlatformSystemMaterialRateDiagnostics,
  type PlatformSystemMaterialRateFact,
  type PlatformSystemMaterialRateMutationMetadata,
  type PlatformSystemMaterialReportingFact,
  type PlatformSystemMaterialSummary,
  type PlatformSystemMaterialVersionDiagnostics,
  type PlatformSystemMaterialVersionFact,
  type PlatformSystemPlanFeatureMapping,
  type PlatformSystemSubscriptionPlanSummary,
  type RevokePlatformPermissionGrantRequest,
  type SchedulePlatformSystemMaterialRateBody,
  type SchedulePlatformSystemMaterialRateRequest,
  type UpdatePlatformSystemCompanyBillingRequest,
  type UpdatePlatformSystemCompanyBillingResponse,
  type UpdatePlatformSystemCompanyPlanBody,
  type UpdatePlatformSystemCompanyPlanRequest,
  type UpdatePlatformSystemCompanyPlanResponse,
  type UpdatePlatformSystemCompanyStatusBody,
  type UpdatePlatformSystemCompanyStatusRequest,
  type UpdatePlatformSystemCompanyStatusResponse,
  type CreatePlatformSystemMaterialDraftRequest,
  type CreatePlatformSystemMaterialDraftResponse,
  type UpdatePlatformSystemMaterialDraftBody,
  type UpdatePlatformSystemMaterialDraftRequest,
  type UpdatePlatformSystemMaterialDraftResponse,
  type UpdatePlatformSystemMaterialRateBody,
  type UpdatePlatformSystemMaterialRateRequest,
  type PublishPlatformSystemMaterialDraftBody,
  type PublishPlatformSystemMaterialDraftRequest,
  type PublishPlatformSystemMaterialDraftResponse,
  type UpdatePlatformSystemFeatureActiveStateBody,
  type UpdatePlatformSystemFeatureActiveStateRequest,
  type UpdatePlatformSystemFeatureActiveStateResponse,
  type UpdatePlatformSystemFeatureMetadataBody,
  type UpdatePlatformSystemFeatureMetadataRequest,
  type UpdatePlatformSystemFeatureMetadataResponse,
  type UpdatePlatformSystemSubscriptionPlanActiveStateBody,
  type UpdatePlatformSystemSubscriptionPlanActiveStateRequest,
  type UpdatePlatformSystemSubscriptionPlanActiveStateResponse,
  type UpdatePlatformSystemSubscriptionPlanMetadataBody,
  type UpdatePlatformSystemSubscriptionPlanMetadataRequest,
  type UpdatePlatformSystemSubscriptionPlanMetadataResponse,
  platformSystemDeploymentModeImpactRiskLevelValues,
  platformSystemMaterialDraftReadinessSeverityValues,
  platformSystemMaterialDraftReadinessStatusValues,
  platformSystemMaterialDraftPublicationStateValues,
  platformSystemMaterialDraftStatusValues,
  platformSystemDeploymentModeImpactTransitionStatusValues,
  platformSystemDeploymentModeImpactTransitionValues,
  platformSystemReceiverDirectoryScopeRiskLevelValues,
  platformSystemReceiverDirectoryScopeTransitionStatusValues,
} from './dto.js';
import {
  billingStatusValues,
  companyStatusValues,
  deploymentModeValues,
  planCodeValues,
} from '../tenancy/company.dto.js';
import { locationKindValues } from '../tenancy/location.dto.js';
import { stationDeviceClaimStatusValues } from '../tenancy/station-recovery.dto.js';
import { stationKindValues, stationStatusValues } from '../tenancy/station.dto.js';
import { storeOperatingModelValues } from '../tenancy/store.dto.js';
import { userStatusValues } from '../users/index.js';
import {
  materialCaptureTypeValues,
  materialCaptureUnitValues,
  materialPresentationTypeValues,
} from '../materials-catalog/materials-catalog.dto.js';

const timestampSchema = z.iso.datetime();
const dateSchema = z.iso.date();
const nonEmptyStringSchema = z.string().trim().min(1);
const auditFilterStringSchema = z.string().trim().min(1).max(200);
const platformSystemFeatureActivationPolicyValues = ['protected', 'standard'] as const;
const materialSearchSchema = z.string().trim().min(1).max(200);
const materialDraftSearchSchema = z.string().trim().min(1).max(200);
const materialDraftCodeSchema = z.string().trim().min(1).max(50);
const materialDraftDisplayNameSchema = z.string().trim().min(1).max(200);
const positiveMaterialRateSchema = z.number().gt(0);
const platformSystemMaterialRateFieldNames = [
  'baseRatePerLb',
  'depositPerPiece',
  'ratePerLb',
] as const;
const strictBooleanQuerySchema = z.preprocess((value) => {
  if (typeof value !== 'string') {
    return value;
  }

  const normalized = value.trim();
  if (normalized === 'true') {
    return true;
  }
  if (normalized === 'false') {
    return false;
  }
  return value;
}, z.boolean());

function expectedPlatformSystemMaterialRateField(
  presentationType: (typeof materialPresentationTypeValues)[number],
): (typeof platformSystemMaterialRateFieldNames)[number] {
  if (presentationType === 'SW') {
    return 'baseRatePerLb';
  }
  if (presentationType === 'SP') {
    return 'ratePerLb';
  }
  return 'depositPerPiece';
}

function validatePlatformSystemMaterialRateChange(
  value: PlatformSystemMaterialRateChangeFields,
  ctx: z.RefinementCtx,
): void {
  const providedFields = platformSystemMaterialRateFieldNames.filter(
    (field) => value[field] !== undefined,
  );
  const expectedField = expectedPlatformSystemMaterialRateField(value.presentationType);

  if (providedFields.length !== 1) {
    ctx.addIssue({
      code: 'custom',
      path: [expectedField],
      message: 'Exactly one presentation-specific rate amount is required.',
    });
    return;
  }

  const providedField = providedFields[0];
  if (providedField !== expectedField) {
    ctx.addIssue({
      code: 'custom',
      path: [providedField],
      message: `${value.presentationType} rates must use ${expectedField}.`,
    });
  }
}

export const PlatformSystemCompanySummarySchema = z
  .object({
    id: z.uuid(),
    name: nonEmptyStringSchema,
    receiverDirectoryScopeId: z.uuid().nullable().optional(),
    status: z.enum(companyStatusValues),
    deploymentMode: z.enum(deploymentModeValues),
    planCode: z.enum(planCodeValues),
    billingStatus: z.enum(billingStatusValues),
    trialExpiresAt: timestampSchema.nullable(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanySummary>;

export const ListPlatformSystemCompaniesRequestSchema = z
  .object({
    status: z.enum(companyStatusValues).optional(),
    deploymentMode: z.enum(deploymentModeValues).optional(),
    planCode: z.enum(planCodeValues).optional(),
    billingStatus: z.enum(billingStatusValues).optional(),
    page: z.number().int().min(1).optional(),
    pageSize: z.number().int().min(1).max(200).optional(),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemCompaniesRequest>;

export const ListPlatformSystemCompaniesResponseSchema = z
  .object({
    items: z.array(PlatformSystemCompanySummarySchema),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(200),
    total: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemCompaniesResponse>;

export const ListPlatformAuditLogsRequestSchema = z
  .object({
    action: auditFilterStringSchema.optional(),
    entityType: auditFilterStringSchema.optional(),
    entityId: auditFilterStringSchema.max(256).optional(),
    permissionKey: auditFilterStringSchema.optional(),
    actorUserId: z.uuid().optional(),
    occurredFrom: timestampSchema.optional(),
    occurredTo: timestampSchema.optional(),
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).optional(),
  })
  .strict()
  .refine(
    (value) =>
      !value.occurredFrom ||
      !value.occurredTo ||
      new Date(value.occurredFrom).getTime() <= new Date(value.occurredTo).getTime(),
    {
      message: 'occurredFrom must be before or equal to occurredTo',
      path: ['occurredFrom'],
    },
  ) satisfies z.ZodType<ListPlatformAuditLogsRequest>;

export const PlatformAuditLogMetadataSummaryEntrySchema = z
  .object({
    kind: z.enum(['value', 'fieldChange', 'count', 'listChange', 'notice']),
    label: nonEmptyStringSchema,
    value: z.union([z.string(), z.number()]).optional(),
    before: z.string().nullable().optional(),
    after: z.string().nullable().optional(),
    beforeValues: z.array(nonEmptyStringSchema).optional(),
    afterValues: z.array(nonEmptyStringSchema).optional(),
    truncatedBeforeCount: z.number().int().min(0).optional(),
    truncatedAfterCount: z.number().int().min(0).optional(),
  })
  .strict() satisfies z.ZodType<PlatformAuditLogMetadataSummaryEntry>;

export const PlatformAuditLogDiagnosticsSchema = z
  .object({
    auditLogId: z.uuid(),
    actorUserId: z.uuid(),
    entityId: nonEmptyStringSchema,
    metadataKeys: z.array(nonEmptyStringSchema),
    createdAt: timestampSchema,
  })
  .strict() satisfies z.ZodType<PlatformAuditLogDiagnostics>;

export const PlatformAuditLogItemSchema = z
  .object({
    occurredAt: timestampSchema,
    action: nonEmptyStringSchema,
    entityType: nonEmptyStringSchema,
    entityLabel: nonEmptyStringSchema,
    actorEmail: nonEmptyStringSchema,
    permissionKey: nonEmptyStringSchema,
    permissionLabel: nonEmptyStringSchema,
    metadataSummary: z.array(PlatformAuditLogMetadataSummaryEntrySchema),
    diagnostics: PlatformAuditLogDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformAuditLogItem>;

export const ListPlatformAuditLogsResponseSchema = z
  .object({
    items: z.array(PlatformAuditLogItemSchema),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(100),
    total: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<ListPlatformAuditLogsResponse>;

export const ListPlatformPermissionGrantsRequestSchema = z
  .object({
    userEmail: z.string().trim().max(200).optional(),
    permissionKey: z.string().trim().max(200).optional(),
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).optional(),
  })
  .strict() satisfies z.ZodType<ListPlatformPermissionGrantsRequest>;

export const PlatformPermissionGrantSummarySchema = z
  .object({
    permissionKey: nonEmptyStringSchema,
    permissionDescription: nonEmptyStringSchema,
    grantedAt: timestampSchema,
  })
  .strict() satisfies z.ZodType<PlatformPermissionGrantSummary>;

export const PlatformPermissionGrantDiagnosticsSchema = z
  .object({
    userId: z.uuid(),
    storage: z.literal('platform_permission_grants'),
  })
  .strict() satisfies z.ZodType<PlatformPermissionGrantDiagnostics>;

export const PlatformPermissionGrantUserItemSchema = z
  .object({
    userEmail: z.email(),
    userStatus: z.enum(userStatusValues),
    grantCount: z.number().int().min(0),
    grantedAtFirst: timestampSchema,
    grantedAtLatest: timestampSchema,
    grants: z.array(PlatformPermissionGrantSummarySchema),
    diagnostics: PlatformPermissionGrantDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformPermissionGrantUserItem>;

export const ListPlatformPermissionGrantsResponseSchema = z
  .object({
    items: z.array(PlatformPermissionGrantUserItemSchema),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(100),
    total: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<ListPlatformPermissionGrantsResponse>;

export const AssignablePlatformPermissionSchema = z
  .object({
    key: nonEmptyStringSchema.max(200),
    description: nonEmptyStringSchema,
  })
  .strict() satisfies z.ZodType<AssignablePlatformPermission>;

export const ListAssignablePlatformGrantPermissionsResponseSchema = z
  .object({
    items: z.array(AssignablePlatformPermissionSchema),
  })
  .strict() satisfies z.ZodType<ListAssignablePlatformGrantPermissionsResponse>;

const platformGrantMutationPermissionKeySchema = z.string().trim().min(1).max(200);
const platformGrantMutationEmailSchema = z.string().trim().min(1).max(200).pipe(z.email());

export const AddPlatformPermissionGrantRequestSchema = z
  .object({
    userEmail: platformGrantMutationEmailSchema,
    permissionKey: platformGrantMutationPermissionKeySchema,
  })
  .strict() satisfies z.ZodType<AddPlatformPermissionGrantRequest>;

export const RevokePlatformPermissionGrantRequestSchema = z
  .object({
    userId: z.uuid(),
    permissionKey: platformGrantMutationPermissionKeySchema,
  })
  .strict() satisfies z.ZodType<RevokePlatformPermissionGrantRequest>;

export const PlatformPermissionGrantMutationSummarySchema = z
  .object({
    kind: z.enum(['added', 'revoked', 'unchanged']),
    targetUserEmail: z.email(),
    targetUserStatus: z.enum(userStatusValues),
    permissionKey: nonEmptyStringSchema.max(200),
    revokedSessionsCount: z.number().int().min(0),
    grantCountBefore: z.number().int().min(0),
    grantCountAfter: z.number().int().min(0),
    selfChange: z.boolean(),
    remainingGrantManagerCount: z.number().int().min(0),
    remainingPlatformGrantedUserCount: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<PlatformPermissionGrantMutationSummary>;

export const MutatePlatformPermissionGrantResponseSchema = z
  .object({
    mutation: PlatformPermissionGrantMutationSummarySchema,
    targetUser: PlatformPermissionGrantUserItemSchema.nullable(),
  })
  .strict() satisfies z.ZodType<MutatePlatformPermissionGrantResponse>;

const companyAuditActionFilterSchema = z.preprocess(
  (value) => (typeof value === 'string' ? value.trim() : value),
  z.enum(platformSystemCompanyAuditActionValues),
);

export const ListPlatformSystemCompanyAuditLogsRequestSchema = z
  .object({
    companyId: z.uuid(),
    action: companyAuditActionFilterSchema.optional(),
    actorUserId: z.uuid().optional(),
    occurredFrom: timestampSchema.optional(),
    occurredTo: timestampSchema.optional(),
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(100).optional(),
  })
  .strict()
  .refine(
    (value) =>
      !value.occurredFrom ||
      !value.occurredTo ||
      new Date(value.occurredFrom).getTime() <= new Date(value.occurredTo).getTime(),
    {
      message: 'occurredFrom must be before or equal to occurredTo',
      path: ['occurredFrom'],
    },
  ) satisfies z.ZodType<ListPlatformSystemCompanyAuditLogsRequest>;

export const PlatformSystemCompanyAuditLogDiagnosticsSchema = z
  .object({
    auditLogId: z.uuid(),
    actorUserId: z.uuid().nullable(),
    companyId: z.uuid(),
    entityId: nonEmptyStringSchema,
    metadataKeys: z.array(nonEmptyStringSchema),
    createdAt: timestampSchema,
    storage: z.literal('audit_logs'),
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanyAuditLogDiagnostics>;

export const PlatformSystemCompanyAuditLogCompanyContextSchema = z
  .object({
    companyId: z.uuid(),
    companyName: nonEmptyStringSchema,
    companyStatus: z.enum(companyStatusValues),
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanyAuditLogCompanyContext>;

export const PlatformSystemCompanyAuditLogItemSchema = z
  .object({
    source: z.literal('companySystem'),
    sourceLabel: z.literal('Company system event'),
    action: z.enum(platformSystemCompanyAuditActionValues),
    eventLabel: nonEmptyStringSchema,
    occurredAt: timestampSchema,
    actorEmail: nonEmptyStringSchema,
    permissionKey: nonEmptyStringSchema.nullable(),
    permissionLabel: nonEmptyStringSchema,
    metadataSummary: z.array(PlatformAuditLogMetadataSummaryEntrySchema),
    diagnostics: PlatformSystemCompanyAuditLogDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanyAuditLogItem>;

export const ListPlatformSystemCompanyAuditLogsResponseSchema = z
  .object({
    company: PlatformSystemCompanyAuditLogCompanyContextSchema,
    items: z.array(PlatformSystemCompanyAuditLogItemSchema),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(100),
    total: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemCompanyAuditLogsResponse>;

export const ListPlatformSystemPlanAffectedCompaniesRequestSchema = z
  .object({
    planCode: z.enum(planCodeValues),
    page: z.number().int().min(1).optional(),
    pageSize: z.number().int().min(1).max(200).optional(),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemPlanAffectedCompaniesRequest>;

export const ListPlatformSystemPlanAffectedCompaniesResponseSchema = z
  .object({
    planCode: z.enum(planCodeValues),
    items: z.array(PlatformSystemCompanySummarySchema),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(200),
    total: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemPlanAffectedCompaniesResponse>;

export const GetPlatformSystemCompanyDetailRequestSchema = z
  .object({
    companyId: z.uuid(),
  })
  .strict() satisfies z.ZodType<GetPlatformSystemCompanyDetailRequest>;

export const PlatformSystemCompanyTopologySummarySchema = z
  .object({
    storesCount: z.number().int().min(0),
    monoStationStoresCount: z.number().int().min(0),
    multiStationStoresCount: z.number().int().min(0),
    locationsCount: z.number().int().min(0),
    activeLocationsCount: z.number().int().min(0),
    inactiveLocationsCount: z.number().int().min(0),
    stationsCount: z.number().int().min(0),
    activeStationsCount: z.number().int().min(0),
    disabledStationsCount: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanyTopologySummary>;

export const PlatformSystemCompanyMembershipSummarySchema = z
  .object({
    membershipsCount: z.number().int().min(0),
    activeMembershipsCount: z.number().int().min(0),
    invitedMembershipsCount: z.number().int().min(0),
    disabledMembershipsCount: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanyMembershipSummary>;

export const PlatformSystemCompanyDetailSchema = z
  .object({
    company: PlatformSystemCompanySummarySchema,
    topology: PlatformSystemCompanyTopologySummarySchema,
    memberships: PlatformSystemCompanyMembershipSummarySchema,
    enabledFeatureKeys: z.array(nonEmptyStringSchema),
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanyDetail>;

export const GetPlatformSystemCompanyDetailResponseSchema = z
  .object({
    companyDetail: PlatformSystemCompanyDetailSchema,
  })
  .strict() satisfies z.ZodType<GetPlatformSystemCompanyDetailResponse>;

export const GetPlatformSystemCompanyDeploymentModeImpactRequestSchema = z
  .object({
    companyId: z.uuid(),
    requestedMode: z.preprocess(
      (value) => (typeof value === 'string' ? value.trim() : value),
      z.enum(deploymentModeValues),
    ),
  })
  .strict() satisfies z.ZodType<GetPlatformSystemCompanyDeploymentModeImpactRequest>;

export const PlatformSystemDeploymentModeImpactCountsSchema = z
  .object({
    storesCount: z.number().int().min(0),
    monoStationStoresCount: z.number().int().min(0),
    multiStationStoresCount: z.number().int().min(0),
    locationsCount: z.number().int().min(0),
    activeLocationsCount: z.number().int().min(0),
    inactiveLocationsCount: z.number().int().min(0),
    stationsCount: z.number().int().min(0),
    activeStationsCount: z.number().int().min(0),
    disabledStationsCount: z.number().int().min(0),
    activeDeviceClaimCount: z.number().int().min(0),
    claimedActiveStationCount: z.number().int().min(0),
    openStoreOperatingSessionCount: z.number().int().min(0),
    cloudReadinessReportCount: z.number().int().min(0),
    readinessParticipantCount: z.number().int().min(0),
    pendingReadinessBlockingEventCount: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<PlatformSystemDeploymentModeImpactCounts>;

export const PlatformSystemDeploymentModeImpactCloudFactsSchema = z
  .object({
    source: z.literal('cloud_api'),
    companyStatus: z.enum(companyStatusValues),
    planCode: z.enum(planCodeValues),
    billingStatus: z.enum(billingStatusValues),
    trialExpiresAt: timestampSchema.nullable(),
    receiverDirectoryScopeId: z.uuid().nullable(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
    enabledFeatureKeys: z.array(nonEmptyStringSchema),
  })
  .strict() satisfies z.ZodType<PlatformSystemDeploymentModeImpactCloudFacts>;

export const PlatformSystemDeploymentModeImpactUnknownLocalFactSchema = z
  .object({
    key: nonEmptyStringSchema,
    label: nonEmptyStringSchema,
    status: z.literal('not_inspected'),
    description: nonEmptyStringSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemDeploymentModeImpactUnknownLocalFact>;

export const PlatformSystemDeploymentModeImpactDiagnosticsSchema = z
  .object({
    companyId: z.uuid(),
    generatedAt: timestampSchema,
    source: z.literal('cloud_api'),
    sourceTables: z.array(nonEmptyStringSchema),
    notes: z.array(nonEmptyStringSchema),
  })
  .strict() satisfies z.ZodType<PlatformSystemDeploymentModeImpactDiagnostics>;

export const PlatformSystemDeploymentModeImpactPreviewSchema = z
  .object({
    company: PlatformSystemCompanySummarySchema,
    currentMode: z.enum(deploymentModeValues),
    requestedMode: z.enum(deploymentModeValues),
    transition: z.enum(platformSystemDeploymentModeImpactTransitionValues),
    mutationSupported: z.literal(false),
    transitionStatus: z.enum(platformSystemDeploymentModeImpactTransitionStatusValues),
    riskLevel: z.enum(platformSystemDeploymentModeImpactRiskLevelValues),
    counts: PlatformSystemDeploymentModeImpactCountsSchema,
    cloudFacts: PlatformSystemDeploymentModeImpactCloudFactsSchema,
    unknownLocalFacts: z.array(PlatformSystemDeploymentModeImpactUnknownLocalFactSchema),
    requiredFutureSteps: z.array(nonEmptyStringSchema),
    warnings: z.array(nonEmptyStringSchema),
    diagnostics: PlatformSystemDeploymentModeImpactDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemDeploymentModeImpactPreview>;

export const GetPlatformSystemCompanyDeploymentModeImpactResponseSchema = z
  .object({
    preview: PlatformSystemDeploymentModeImpactPreviewSchema,
  })
  .strict() satisfies z.ZodType<GetPlatformSystemCompanyDeploymentModeImpactResponse>;

export const PreviewPlatformSystemCompanyReceiverDirectoryScopeRequestSchema = z
  .object({
    targetScopeId: z.uuid(),
  })
  .strict() satisfies z.ZodType<PreviewPlatformSystemCompanyReceiverDirectoryScopeRequest>;

export const PlatformSystemReceiverDirectoryCurrentScopeSchema = z
  .object({
    normalizedScopeId: z.uuid(),
    storedScopeId: z.uuid().nullable(),
    source: z.enum(['stored_company_scope', 'company_id_legacy_fallback']),
  })
  .strict() satisfies z.ZodType<PlatformSystemReceiverDirectoryCurrentScope>;

export const PlatformSystemReceiverDirectoryTargetScopeSchema = z
  .object({
    scopeId: z.uuid(),
    inputKind: z.literal('uuid'),
    ownership: z.literal('not_evaluated'),
  })
  .strict() satisfies z.ZodType<PlatformSystemReceiverDirectoryTargetScope>;

export const PlatformSystemReceiverDirectoryScopeImpactCountsSchema = z
  .object({
    companyOwnedReceiversInCurrentScopeCount: z.number().int().min(0),
    companyOwnedReceiversOutsideCurrentScopeCount: z.number().int().min(0),
    companyOwnedReceiversInTargetScopeCount: z.number().int().min(0),
    shipmentReceiverReferenceCount: z.number().int().min(0),
    inboundReceiptReceiverReferenceCount: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<PlatformSystemReceiverDirectoryScopeImpactCounts>;

export const PlatformSystemReceiverDirectoryScopeCloudFactsSchema = z
  .object({
    source: z.literal('cloud_api'),
    companyStatus: z.enum(companyStatusValues),
    planCode: z.enum(planCodeValues),
    billingStatus: z.enum(billingStatusValues),
    trialExpiresAt: timestampSchema.nullable(),
    currentScopeStorage: z.enum(['company.receiverDirectoryScopeId', 'company.id_legacy_fallback']),
    countBoundary: z.literal('owner_company_only'),
    targetScopeOwnership: z.literal('not_evaluated'),
    crossCompanyScopeDisclosure: z.literal('not_disclosed'),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
    enabledFeatureKeys: z.array(nonEmptyStringSchema),
  })
  .strict() satisfies z.ZodType<PlatformSystemReceiverDirectoryScopeCloudFacts>;

export const PlatformSystemReceiverDirectoryScopeUnknownLocalFactSchema = z
  .object({
    key: nonEmptyStringSchema,
    label: nonEmptyStringSchema,
    status: z.literal('not_inspected'),
    description: nonEmptyStringSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemReceiverDirectoryScopeUnknownLocalFact>;

export const PlatformSystemReceiverDirectoryScopeDiagnosticsSchema = z
  .object({
    companyId: z.uuid(),
    normalizedCurrentScopeId: z.uuid(),
    targetScopeId: z.uuid(),
    storedReceiverDirectoryScopeId: z.uuid().nullable(),
    generatedAt: timestampSchema,
    source: z.literal('cloud_api'),
    sourceTables: z.array(nonEmptyStringSchema),
    notes: z.array(nonEmptyStringSchema),
  })
  .strict() satisfies z.ZodType<PlatformSystemReceiverDirectoryScopeDiagnostics>;

export const PlatformSystemReceiverDirectoryScopePreviewSchema = z
  .object({
    company: PlatformSystemCompanySummarySchema,
    currentScope: PlatformSystemReceiverDirectoryCurrentScopeSchema,
    targetScope: PlatformSystemReceiverDirectoryTargetScopeSchema,
    normalizedCurrentScopeId: z.uuid(),
    targetScopeId: z.uuid(),
    sameScope: z.boolean(),
    mutationSupported: z.literal(false),
    transitionStatus: z.enum(platformSystemReceiverDirectoryScopeTransitionStatusValues),
    riskLevel: z.enum(platformSystemReceiverDirectoryScopeRiskLevelValues),
    counts: PlatformSystemReceiverDirectoryScopeImpactCountsSchema,
    cloudFacts: PlatformSystemReceiverDirectoryScopeCloudFactsSchema,
    desktopLocalState: z.literal('not_inspected'),
    unknownLocalFacts: z.array(PlatformSystemReceiverDirectoryScopeUnknownLocalFactSchema),
    warnings: z.array(nonEmptyStringSchema),
    requiredFutureWork: z.array(nonEmptyStringSchema),
    diagnostics: PlatformSystemReceiverDirectoryScopeDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemReceiverDirectoryScopePreview>;

export const PreviewPlatformSystemCompanyReceiverDirectoryScopeResponseSchema = z
  .object({
    preview: PlatformSystemReceiverDirectoryScopePreviewSchema,
  })
  .strict() satisfies z.ZodType<PreviewPlatformSystemCompanyReceiverDirectoryScopeResponse>;

export const PlatformSystemCompanyStationContextSchema = z
  .object({
    companyId: z.uuid(),
    companyName: nonEmptyStringSchema,
    companyStatus: z.enum(companyStatusValues),
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanyStationContext>;

export const PlatformSystemCompanyStationDiagnosticsSchema = z
  .object({
    companyId: z.uuid(),
    stationId: z.uuid(),
    storeId: z.uuid(),
    locationId: z.uuid(),
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanyStationDiagnostics>;

export const PlatformSystemStationAssignmentSummarySchema = z
  .object({
    stationName: nonEmptyStringSchema,
    stationKind: z.enum(stationKindValues),
    stationStatus: z.enum(stationStatusValues),
    isOfflineCapable: z.boolean(),
    storeName: nonEmptyStringSchema,
    storeCode: z.string().trim().min(1).nullable(),
    storeOperatingModel: z.enum(storeOperatingModelValues),
    locationName: nonEmptyStringSchema,
    locationCode: nonEmptyStringSchema,
    locationKind: z.enum(locationKindValues),
    locationIsActive: z.boolean(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemStationAssignmentSummary>;

export const PlatformSystemStationDeviceClaimDiagnosticsSchema = z
  .object({
    claimId: z.uuid(),
    deviceId: z.uuid(),
    previousDeviceClaimId: z.uuid().nullable(),
    supersededByClaimId: z.uuid().nullable(),
  })
  .strict() satisfies z.ZodType<PlatformSystemStationDeviceClaimDiagnostics>;

export const PlatformSystemStationDeviceClaimSummarySchema = z
  .object({
    claimStatus: z.enum(stationDeviceClaimStatusValues),
    authorizedAt: timestampSchema,
    activatedAt: timestampSchema.nullable(),
    supersededAt: timestampSchema.nullable(),
    failedAt: timestampSchema.nullable(),
    expiresAt: timestampSchema,
    desktopReleaseChannel: z.string().trim().min(1).max(64).nullable(),
    desktopAppVersion: z.string().trim().min(1).max(64).nullable(),
    diagnostics: PlatformSystemStationDeviceClaimDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemStationDeviceClaimSummary>;

export const PlatformSystemStationReadinessDiagnosticsSchema = z
  .object({
    sessionKey: nonEmptyStringSchema,
    primaryStationId: z.uuid(),
  })
  .strict() satisfies z.ZodType<PlatformSystemStationReadinessDiagnostics>;

export const PlatformSystemStationReadinessParticipantDiagnosticsSchema = z
  .object({
    stationId: z.uuid(),
  })
  .strict() satisfies z.ZodType<PlatformSystemStationReadinessParticipantDiagnostics>;

export const PlatformSystemStationReadinessParticipantSchema = z
  .object({
    stationName: nonEmptyStringSchema.nullable(),
    joinedAt: timestampSchema,
    persistedLocally: z.boolean(),
    lastReadinessConfirmedAt: timestampSchema.nullable(),
    pendingBlockingEventCount: z.number().int().min(0),
    blockingReason: nonEmptyStringSchema,
    lastHeartbeatAt: timestampSchema.nullable(),
    diagnostics: PlatformSystemStationReadinessParticipantDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemStationReadinessParticipant>;

export const PlatformSystemStationReadinessReportSummarySchema = z
  .object({
    businessDate: dateSchema,
    sessionStatus: z.enum(['OPEN', 'CLOSED']),
    timeZone: nonEmptyStringSchema,
    cloudVisibleAt: timestampSchema.nullable(),
    openedAt: timestampSchema,
    closedAt: timestampSchema.nullable(),
    participantCount: z.number().int().min(0),
    confirmedParticipantCount: z.number().int().min(0),
    pendingBlockingEventCount: z.number().int().min(0),
    latestReadinessConfirmedAt: timestampSchema.nullable(),
    latestHeartbeatAt: timestampSchema.nullable(),
    updatedAt: timestampSchema,
    diagnostics: PlatformSystemStationReadinessDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemStationReadinessReportSummary>;

export const PlatformSystemStationReadinessReportDetailSchema =
  PlatformSystemStationReadinessReportSummarySchema.extend({
    participants: z.array(PlatformSystemStationReadinessParticipantSchema),
  }).strict() satisfies z.ZodType<PlatformSystemStationReadinessReportDetail>;

export const PlatformSystemStationDataAvailabilityRowSchema = z
  .object({
    key: nonEmptyStringSchema,
    label: nonEmptyStringSchema,
    status: z.enum(platformSystemStationDataAvailabilityStatusValues),
    description: nonEmptyStringSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemStationDataAvailabilityRow>;

export const PlatformSystemStationSupportDiagnosticRowSchema = z
  .object({
    label: nonEmptyStringSchema,
    value: z.string().trim().min(1).nullable(),
  })
  .strict() satisfies z.ZodType<PlatformSystemStationSupportDiagnosticRow>;

export const PlatformSystemCompanyStationListItemSchema = z
  .object({
    assignment: PlatformSystemStationAssignmentSummarySchema,
    activeDeviceClaim: PlatformSystemStationDeviceClaimSummarySchema.nullable(),
    latestReadinessReport: PlatformSystemStationReadinessReportSummarySchema.nullable(),
    diagnostics: PlatformSystemCompanyStationDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanyStationListItem>;

export const ListPlatformSystemCompanyStationsRequestSchema = z
  .object({
    companyId: z.uuid(),
    storeId: z.uuid().optional(),
    locationId: z.uuid().optional(),
    stationStatus: z.enum(stationStatusValues).optional(),
    claimStatus: z.enum(platformSystemStationClaimStatusFilterValues).optional(),
    q: z.string().trim().min(1).max(200).optional(),
    businessDate: dateSchema.optional(),
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(200).optional(),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemCompanyStationsRequest>;

export const ListPlatformSystemCompanyStationsResponseSchema = z
  .object({
    company: PlatformSystemCompanyStationContextSchema,
    items: z.array(PlatformSystemCompanyStationListItemSchema),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(200),
    total: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemCompanyStationsResponse>;

export const GetPlatformSystemCompanyStationDetailRequestSchema = z
  .object({
    companyId: z.uuid(),
    stationId: z.uuid(),
    businessDate: dateSchema.optional(),
  })
  .strict() satisfies z.ZodType<GetPlatformSystemCompanyStationDetailRequest>;

export const PlatformSystemCompanyStationDetailSchema = z
  .object({
    company: PlatformSystemCompanyStationContextSchema,
    assignment: PlatformSystemStationAssignmentSummarySchema,
    activeDeviceClaim: PlatformSystemStationDeviceClaimSummarySchema.nullable(),
    deviceClaimHistory: z.array(PlatformSystemStationDeviceClaimSummarySchema),
    latestReadinessReport: PlatformSystemStationReadinessReportDetailSchema.nullable(),
    dataAvailability: z.array(PlatformSystemStationDataAvailabilityRowSchema),
    supportDiagnostics: z.array(PlatformSystemStationSupportDiagnosticRowSchema),
  })
  .strict() satisfies z.ZodType<PlatformSystemCompanyStationDetail>;

export const GetPlatformSystemCompanyStationDetailResponseSchema = z
  .object({
    stationDetail: PlatformSystemCompanyStationDetailSchema,
  })
  .strict() satisfies z.ZodType<GetPlatformSystemCompanyStationDetailResponse>;

export const UpdatePlatformSystemCompanyBillingRequestSchema = z
  .object({
    companyId: z.uuid(),
    billingStatus: z.enum(billingStatusValues).optional(),
    trialExpiresAt: timestampSchema.nullable().optional(),
  })
  .strict()
  .refine((value) => value.billingStatus !== undefined || value.trialExpiresAt !== undefined, {
    message: 'At least one billing field must be provided',
  }) satisfies z.ZodType<UpdatePlatformSystemCompanyBillingRequest>;

export const UpdatePlatformSystemCompanyBillingResponseSchema = z
  .object({
    companyDetail: PlatformSystemCompanyDetailSchema,
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemCompanyBillingResponse>;

export const UpdatePlatformSystemCompanyPlanBodySchema = z
  .object({
    planCode: z.enum(planCodeValues),
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemCompanyPlanBody>;

export const UpdatePlatformSystemCompanyPlanRequestSchema = z
  .object({
    companyId: z.uuid(),
    planCode: z.enum(planCodeValues),
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemCompanyPlanRequest>;

export const UpdatePlatformSystemCompanyPlanResponseSchema = z
  .object({
    companyDetail: PlatformSystemCompanyDetailSchema,
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemCompanyPlanResponse>;

export const UpdatePlatformSystemCompanyStatusBodySchema = z
  .object({
    status: z.enum(companyStatusValues),
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemCompanyStatusBody>;

export const UpdatePlatformSystemCompanyStatusRequestSchema = z
  .object({
    companyId: z.uuid(),
    status: z.enum(companyStatusValues),
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemCompanyStatusRequest>;

export const UpdatePlatformSystemCompanyStatusResponseSchema = z
  .object({
    companyDetail: PlatformSystemCompanyDetailSchema,
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemCompanyStatusResponse>;

export const PlatformSystemFeatureSummarySchema = z
  .object({
    key: nonEmptyStringSchema,
    module: nonEmptyStringSchema,
    level: nonEmptyStringSchema,
    description: nonEmptyStringSchema,
    isActive: z.boolean(),
    activationPolicy: z.enum(platformSystemFeatureActivationPolicyValues),
    isProtected: z.boolean(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemFeatureSummary>;

export const ListPlatformSystemFeatureAffectedCompaniesRequestSchema = z
  .object({
    featureKey: nonEmptyStringSchema,
    page: z.number().int().min(1).optional(),
    pageSize: z.number().int().min(1).max(200).optional(),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemFeatureAffectedCompaniesRequest>;

export const ListPlatformSystemFeatureAffectedCompaniesResponseSchema = z
  .object({
    feature: PlatformSystemFeatureSummarySchema,
    mappedPlanCodes: z.array(z.enum(planCodeValues)),
    items: z.array(PlatformSystemCompanySummarySchema),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(200),
    total: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemFeatureAffectedCompaniesResponse>;

export const PlatformSystemPlanFeatureMappingSchema = z
  .object({
    planCode: z.enum(planCodeValues),
    featureKey: nonEmptyStringSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemPlanFeatureMapping>;

export const PlatformSystemSubscriptionPlanSummarySchema = z
  .object({
    code: z.enum(planCodeValues),
    name: nonEmptyStringSchema,
    description: nonEmptyStringSchema,
    level: z.number().int(),
    includedStores: z.number().int().nonnegative(),
    includedStations: z.number().int().nonnegative(),
    unlimitedStations: z.boolean(),
    isActive: z.boolean(),
    mappedFeatureKeys: z.array(nonEmptyStringSchema),
    activeEnabledFeatureKeys: z.array(nonEmptyStringSchema),
    enabledFeatureKeys: z.array(nonEmptyStringSchema),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemSubscriptionPlanSummary>;

export const GetPlatformSystemBillingCatalogResponseSchema = z
  .object({
    plans: z.array(PlatformSystemSubscriptionPlanSummarySchema),
    features: z.array(PlatformSystemFeatureSummarySchema),
    planFeatures: z.array(PlatformSystemPlanFeatureMappingSchema),
  })
  .strict() satisfies z.ZodType<GetPlatformSystemBillingCatalogResponse>;

export const ListPlatformSystemMaterialsRequestSchema = z
  .object({
    effectiveOn: dateSchema.optional(),
    includeInactive: strictBooleanQuerySchema.optional(),
    includeFuture: strictBooleanQuerySchema.optional(),
    q: materialSearchSchema.optional(),
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(200).optional(),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemMaterialsRequest>;

export const GetPlatformSystemMaterialDetailRequestSchema = z
  .object({
    materialId: z.uuid(),
    effectiveOn: dateSchema.optional(),
    includeInactive: strictBooleanQuerySchema.optional(),
    includeFuture: strictBooleanQuerySchema.optional(),
  })
  .strict() satisfies z.ZodType<GetPlatformSystemMaterialDetailRequest>;

export const PlatformSystemMaterialPresentationFactSchema = z
  .object({
    type: z.enum(materialPresentationTypeValues),
    unit: z.enum(materialCaptureUnitValues),
    captureType: z.enum(materialCaptureTypeValues),
    allowsFractional: z.boolean(),
    isCrvEligible: z.boolean(),
    isReportedToDoriis: z.boolean(),
    presentationOrder: z.number().int().min(0).nullable(),
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialPresentationFact>;

export const PlatformSystemMaterialRateDiagnosticsSchema = z
  .object({
    materialId: z.uuid(),
    priceVersionId: z.uuid(),
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialRateDiagnostics>;

export const PlatformSystemMaterialRateFactSchema = z
  .object({
    presentationType: z.enum(materialPresentationTypeValues),
    rateField: z.enum(['baseRatePerLb', 'depositPerPiece', 'ratePerLb']),
    rateLabel: nonEmptyStringSchema,
    amount: z.number().min(0),
    effectiveState: z.enum(platformSystemMaterialRateEffectiveStateValues),
    effectiveAtUtc: timestampSchema,
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
    diagnostics: PlatformSystemMaterialRateDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialRateFact>;

export const PlatformSystemMaterialDoriisMappingSchema = z
  .object({
    officialSystem: z.enum(platformSystemMaterialDoriisOfficialSystemValues),
    reportingMaterialCode: nonEmptyStringSchema.max(80),
    reportingMaterialName: nonEmptyStringSchema.max(200),
    reportingBasis: nonEmptyStringSchema.max(500),
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialDoriisMapping>;

export const PlatformSystemMaterialVersionDiagnosticsSchema = z
  .object({
    materialId: z.uuid(),
    materialVersionId: z.uuid(),
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialVersionDiagnostics>;

export const PlatformSystemMaterialVersionFactSchema = z
  .object({
    code: z.string().trim().min(1).max(50).nullable(),
    displayName: nonEmptyStringSchema,
    categoryOrder: z.number().int().min(0).nullable(),
    materialOrder: z.number().int().min(0).nullable(),
    isActive: z.boolean(),
    isCrvEligible: z.boolean(),
    doriisMapping: PlatformSystemMaterialDoriisMappingSchema.nullable(),
    maxPiecesPerLine: z.number().int().min(1),
    dailyCrvLimitLbs: z.number().min(0).nullable(),
    effectiveFrom: dateSchema,
    effectiveTo: dateSchema.nullable(),
    presentations: z.array(PlatformSystemMaterialPresentationFactSchema),
    diagnostics: PlatformSystemMaterialVersionDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialVersionFact>;

export const PlatformSystemMaterialDiagnosticsSchema = z
  .object({
    materialId: z.uuid(),
    currentVersionId: z.uuid().nullable(),
    sourceTables: z.array(nonEmptyStringSchema),
    seedOwned: z.literal(true),
    mutationSupported: z.boolean(),
    generatedAt: timestampSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialDiagnostics>;

export const PlatformSystemMaterialSummarySchema = z
  .object({
    code: z.string().trim().min(1).max(50).nullable(),
    displayName: nonEmptyStringSchema,
    categoryOrder: z.number().int().min(0).nullable(),
    materialOrder: z.number().int().min(0).nullable(),
    isActive: z.boolean(),
    isCrvEligible: z.boolean(),
    doriisMapping: PlatformSystemMaterialDoriisMappingSchema.nullable(),
    maxPiecesPerLine: z.number().int().min(1),
    dailyCrvLimitLbs: z.number().min(0).nullable(),
    effectiveState: z.enum(platformSystemMaterialEffectiveStateValues),
    effectiveFrom: dateSchema,
    effectiveTo: dateSchema.nullable(),
    presentations: z.array(PlatformSystemMaterialPresentationFactSchema),
    currentRates: z.array(PlatformSystemMaterialRateFactSchema),
    warnings: z.array(nonEmptyStringSchema),
    diagnostics: PlatformSystemMaterialDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialSummary>;

export const PlatformSystemMaterialGovernanceNoteSchema = z
  .object({
    severity: z.enum(platformSystemMaterialGovernanceNoteSeverityValues),
    code: nonEmptyStringSchema,
    title: nonEmptyStringSchema,
    detail: nonEmptyStringSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialGovernanceNote>;

export const PlatformSystemMaterialReportingFactSchema = z
  .object({
    label: nonEmptyStringSchema,
    value: nonEmptyStringSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialReportingFact>;

export const PlatformSystemMaterialDetailSchema = PlatformSystemMaterialSummarySchema.extend({
  versionHistory: z.array(PlatformSystemMaterialVersionFactSchema),
  priceHistory: z.array(PlatformSystemMaterialRateFactSchema),
  reportingFacts: z.array(PlatformSystemMaterialReportingFactSchema),
  governanceNotes: z.array(PlatformSystemMaterialGovernanceNoteSchema),
}).strict() satisfies z.ZodType<PlatformSystemMaterialDetail>;

export const ListPlatformSystemMaterialsResponseSchema = z
  .object({
    effectiveOn: dateSchema,
    includeInactive: z.boolean(),
    includeFuture: z.boolean(),
    items: z.array(PlatformSystemMaterialSummarySchema),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(200),
    total: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemMaterialsResponse>;

export const GetPlatformSystemMaterialDetailResponseSchema = z
  .object({
    material: PlatformSystemMaterialDetailSchema,
  })
  .strict() satisfies z.ZodType<GetPlatformSystemMaterialDetailResponse>;

const futureMaterialRateDateSchema = dateSchema.refine(isFutureIsoDate, {
  message: 'effectiveOn must be a future date',
});

const platformSystemMaterialRateChangeShape = {
  presentationType: z.enum(materialPresentationTypeValues),
  effectiveOn: futureMaterialRateDateSchema,
  baseRatePerLb: positiveMaterialRateSchema.optional(),
  depositPerPiece: positiveMaterialRateSchema.optional(),
  ratePerLb: positiveMaterialRateSchema.optional(),
};

export const SchedulePlatformSystemMaterialRateBodySchema = z
  .object(platformSystemMaterialRateChangeShape)
  .strict()
  .superRefine(
    validatePlatformSystemMaterialRateChange,
  ) satisfies z.ZodType<SchedulePlatformSystemMaterialRateBody>;

export const SchedulePlatformSystemMaterialRateRequestSchema = z
  .object({
    materialId: z.uuid(),
    ...platformSystemMaterialRateChangeShape,
  })
  .strict()
  .superRefine(
    validatePlatformSystemMaterialRateChange,
  ) satisfies z.ZodType<SchedulePlatformSystemMaterialRateRequest>;

export const UpdatePlatformSystemMaterialRateBodySchema = z
  .object(platformSystemMaterialRateChangeShape)
  .strict()
  .superRefine(
    validatePlatformSystemMaterialRateChange,
  ) satisfies z.ZodType<UpdatePlatformSystemMaterialRateBody>;

export const UpdatePlatformSystemMaterialRateRequestSchema = z
  .object({
    materialId: z.uuid(),
    priceVersionId: z.uuid(),
    ...platformSystemMaterialRateChangeShape,
  })
  .strict()
  .superRefine(
    validatePlatformSystemMaterialRateChange,
  ) satisfies z.ZodType<UpdatePlatformSystemMaterialRateRequest>;

export const PlatformSystemMaterialRateMutationMetadataSchema = z
  .object({
    kind: z.enum(platformSystemMaterialRateMutationKindValues),
    materialId: z.uuid(),
    priceVersionId: z.uuid(),
    presentationType: z.enum(materialPresentationTypeValues),
    effectiveOn: dateSchema,
    permissionKey: nonEmptyStringSchema,
    auditWritten: z.boolean(),
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialRateMutationMetadata>;

export const MutatePlatformSystemMaterialRateResponseSchema = z
  .object({
    material: PlatformSystemMaterialDetailSchema,
    priceVersion: PlatformSystemMaterialRateFactSchema,
    mutation: PlatformSystemMaterialRateMutationMetadataSchema,
  })
  .strict() satisfies z.ZodType<MutatePlatformSystemMaterialRateResponse>;

export const PlatformSystemMaterialActivationReadinessIssueSchema = z
  .object({
    code: nonEmptyStringSchema,
    severity: z.enum(platformSystemMaterialActivationReadinessSeverityValues),
    message: nonEmptyStringSchema,
    field: nonEmptyStringSchema.optional(),
    presentationType: z.enum(materialPresentationTypeValues).optional(),
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialActivationReadinessIssue>;

const platformSystemMaterialActivationFieldsSchema = z
  .object({
    materialVersionId: z.uuid(),
    effectiveOn: dateSchema,
    activationState: z.enum(platformSystemMaterialActivationStateValues),
    confirmFutureActivation: z.literal(true),
  })
  .strict();

export const ActivatePlatformSystemMaterialBodySchema =
  platformSystemMaterialActivationFieldsSchema satisfies z.ZodType<ActivatePlatformSystemMaterialBody>;

export const ActivatePlatformSystemMaterialRequestSchema =
  platformSystemMaterialActivationFieldsSchema
    .extend({
      materialId: z.uuid(),
    })
    .strict() satisfies z.ZodType<ActivatePlatformSystemMaterialRequest>;

export const PlatformSystemMaterialActivationResultSchema = z
  .object({
    materialId: z.uuid(),
    materialVersionId: z.uuid(),
    activationState: z.enum(platformSystemMaterialActivationStateValues),
    effectiveOn: dateSchema,
    readinessStatus: z.enum(platformSystemMaterialActivationReadinessStatusValues),
    readinessIssues: z.array(PlatformSystemMaterialActivationReadinessIssueSchema),
    activatedAt: timestampSchema,
    activatedByUserId: z.uuid(),
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialActivationResult>;

export const ActivatePlatformSystemMaterialResponseSchema = z
  .object({
    material: PlatformSystemMaterialDetailSchema,
    activatedVersion: PlatformSystemMaterialVersionFactSchema,
    activation: PlatformSystemMaterialActivationResultSchema,
  })
  .strict() satisfies z.ZodType<ActivatePlatformSystemMaterialResponse>;

export const PlatformSystemMaterialDraftReadinessIssueSchema = z
  .object({
    code: nonEmptyStringSchema,
    severity: z.enum(platformSystemMaterialDraftReadinessSeverityValues),
    message: nonEmptyStringSchema,
    field: nonEmptyStringSchema.optional(),
    presentationType: z.enum(materialPresentationTypeValues).optional(),
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialDraftReadinessIssue>;

export const PlatformSystemMaterialDraftDiagnosticsSchema = z
  .object({
    draftId: z.uuid(),
    reservedFutureMaterialId: z.uuid(),
    sourceTables: z.array(nonEmptyStringSchema),
    createdByUserId: z.uuid(),
    updatedByUserId: z.uuid(),
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialDraftDiagnostics>;

const PlatformSystemMaterialDraftPresentationTypesSchema = z
  .array(z.enum(materialPresentationTypeValues))
  .superRefine((values, ctx) => {
    if (new Set(values).size !== values.length) {
      ctx.addIssue({
        code: 'custom',
        message: 'Presentation types must be unique',
      });
    }
  });

const futureDraftRateDateSchema = dateSchema.refine(isFutureIsoDate, {
  message: 'effectiveOn must be a future date',
});

const PlatformSystemMaterialDraftSwInitialRateSchema = z
  .object({
    presentationType: z.literal('SW'),
    effectiveOn: futureDraftRateDateSchema,
    baseRatePerLb: z.number().min(0),
  })
  .strict();

const PlatformSystemMaterialDraftScInitialRateSchema = z
  .object({
    presentationType: z.enum(['SCL', 'SCS', 'SC25']),
    effectiveOn: futureDraftRateDateSchema,
    depositPerPiece: z.number().min(0),
  })
  .strict();

const PlatformSystemMaterialDraftSpInitialRateSchema = z
  .object({
    presentationType: z.literal('SP'),
    effectiveOn: futureDraftRateDateSchema,
    ratePerLb: z.number().min(0),
  })
  .strict();

export const PlatformSystemMaterialDraftInitialRateSchema = z.discriminatedUnion(
  'presentationType',
  [
    PlatformSystemMaterialDraftSwInitialRateSchema,
    PlatformSystemMaterialDraftScInitialRateSchema,
    PlatformSystemMaterialDraftSpInitialRateSchema,
  ],
) satisfies z.ZodType<PlatformSystemMaterialDraftInitialRate>;

const PlatformSystemMaterialDraftInitialRatesSchema = z
  .array(PlatformSystemMaterialDraftInitialRateSchema)
  .superRefine((values, ctx) => {
    const seen = new Set<string>();
    values.forEach((value, index) => {
      if (seen.has(value.presentationType)) {
        ctx.addIssue({
          code: 'custom',
          message: 'Initial rates must be unique by presentation type',
          path: [index, 'presentationType'],
        });
      }
      seen.add(value.presentationType);
    });
  });

export const PlatformSystemMaterialDraftSummarySchema = z
  .object({
    status: z.enum(platformSystemMaterialDraftStatusValues),
    code: materialDraftCodeSchema,
    normalizedCode: materialDraftCodeSchema,
    displayName: materialDraftDisplayNameSchema,
    isCrvEligible: z.boolean(),
    doriisMapping: PlatformSystemMaterialDoriisMappingSchema.nullable(),
    maxPiecesPerLine: z.number().int().min(1),
    dailyCrvLimitLbs: z.number().min(0).nullable(),
    presentations: PlatformSystemMaterialDraftPresentationTypesSchema,
    initialRatePresentationTypes: PlatformSystemMaterialDraftPresentationTypesSchema,
    readinessStatus: z.enum(platformSystemMaterialDraftReadinessStatusValues),
    readinessIssues: z.array(PlatformSystemMaterialDraftReadinessIssueSchema),
    publishedAt: timestampSchema.nullable(),
    publishedByUserId: z.uuid().nullable(),
    publishedMaterialId: z.uuid().nullable(),
    publishedMaterialVersionId: z.uuid().nullable(),
    createdAt: timestampSchema,
    updatedAt: timestampSchema,
    diagnostics: PlatformSystemMaterialDraftDiagnosticsSchema,
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialDraftSummary>;

export const PlatformSystemMaterialDraftDetailSchema =
  PlatformSystemMaterialDraftSummarySchema.extend({
    initialRates: PlatformSystemMaterialDraftInitialRatesSchema,
  }).strict() satisfies z.ZodType<PlatformSystemMaterialDraftDetail>;

export const ListPlatformSystemMaterialDraftsRequestSchema = z
  .object({
    q: materialDraftSearchSchema.optional(),
    page: z.coerce.number().int().min(1).optional(),
    pageSize: z.coerce.number().int().min(1).max(200).optional(),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemMaterialDraftsRequest>;

export const ListPlatformSystemMaterialDraftsResponseSchema = z
  .object({
    items: z.array(PlatformSystemMaterialDraftSummarySchema),
    page: z.number().int().min(1),
    pageSize: z.number().int().min(1).max(200),
    total: z.number().int().min(0),
  })
  .strict() satisfies z.ZodType<ListPlatformSystemMaterialDraftsResponse>;

export const GetPlatformSystemMaterialDraftRequestSchema = z
  .object({
    draftId: z.uuid(),
  })
  .strict() satisfies z.ZodType<GetPlatformSystemMaterialDraftRequest>;

export const GetPlatformSystemMaterialDraftResponseSchema = z
  .object({
    draft: PlatformSystemMaterialDraftDetailSchema,
  })
  .strict() satisfies z.ZodType<GetPlatformSystemMaterialDraftResponse>;

export const CreatePlatformSystemMaterialDraftRequestSchema = z
  .object({
    code: materialDraftCodeSchema,
    displayName: materialDraftDisplayNameSchema,
    isCrvEligible: z.boolean(),
    doriisMapping: PlatformSystemMaterialDoriisMappingSchema.nullable().optional(),
    maxPiecesPerLine: z.number().int().min(1).optional(),
    dailyCrvLimitLbs: z.number().min(0).nullable().optional(),
    presentations: PlatformSystemMaterialDraftPresentationTypesSchema.optional(),
    initialRates: PlatformSystemMaterialDraftInitialRatesSchema.optional(),
  })
  .strict() satisfies z.ZodType<CreatePlatformSystemMaterialDraftRequest>;

export const CreatePlatformSystemMaterialDraftResponseSchema = z
  .object({
    draft: PlatformSystemMaterialDraftDetailSchema,
  })
  .strict() satisfies z.ZodType<CreatePlatformSystemMaterialDraftResponse>;

const updatePlatformSystemMaterialDraftFieldsSchema = z
  .object({
    code: materialDraftCodeSchema.optional(),
    displayName: materialDraftDisplayNameSchema.optional(),
    isCrvEligible: z.boolean().optional(),
    doriisMapping: PlatformSystemMaterialDoriisMappingSchema.nullable().optional(),
    maxPiecesPerLine: z.number().int().min(1).optional(),
    dailyCrvLimitLbs: z.number().min(0).nullable().optional(),
    presentations: PlatformSystemMaterialDraftPresentationTypesSchema.optional(),
    initialRates: PlatformSystemMaterialDraftInitialRatesSchema.optional(),
  })
  .strict();

export const UpdatePlatformSystemMaterialDraftBodySchema =
  updatePlatformSystemMaterialDraftFieldsSchema satisfies z.ZodType<UpdatePlatformSystemMaterialDraftBody>;

export const UpdatePlatformSystemMaterialDraftRequestSchema =
  updatePlatformSystemMaterialDraftFieldsSchema
    .extend({
      draftId: z.uuid(),
    })
    .strict() satisfies z.ZodType<UpdatePlatformSystemMaterialDraftRequest>;

export const UpdatePlatformSystemMaterialDraftResponseSchema = z
  .object({
    draft: PlatformSystemMaterialDraftDetailSchema,
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemMaterialDraftResponse>;

const platformSystemMaterialDraftPublicationFieldsSchema = z
  .object({
    effectiveOn: futureDraftRateDateSchema,
    publicationState: z.enum(platformSystemMaterialDraftPublicationStateValues),
  })
  .strict();

export const PublishPlatformSystemMaterialDraftBodySchema =
  platformSystemMaterialDraftPublicationFieldsSchema satisfies z.ZodType<PublishPlatformSystemMaterialDraftBody>;

export const PublishPlatformSystemMaterialDraftRequestSchema =
  platformSystemMaterialDraftPublicationFieldsSchema
    .extend({
      draftId: z.uuid(),
    })
    .strict() satisfies z.ZodType<PublishPlatformSystemMaterialDraftRequest>;

export const PlatformSystemMaterialDraftPublicationResultSchema = z
  .object({
    draftId: z.uuid(),
    publishedMaterialId: z.uuid(),
    publishedMaterialVersionId: z.uuid(),
    publicationState: z.enum(platformSystemMaterialDraftPublicationStateValues),
    effectiveOn: dateSchema,
    publishedAt: timestampSchema,
    publishedByUserId: z.uuid(),
  })
  .strict() satisfies z.ZodType<PlatformSystemMaterialDraftPublicationResult>;

export const PublishPlatformSystemMaterialDraftResponseSchema = z
  .object({
    draft: PlatformSystemMaterialDraftDetailSchema,
    material: PlatformSystemMaterialDetailSchema,
    publication: PlatformSystemMaterialDraftPublicationResultSchema,
  })
  .strict() satisfies z.ZodType<PublishPlatformSystemMaterialDraftResponse>;

const subscriptionPlanMetadataFieldsSchema = z
  .object({
    name: nonEmptyStringSchema.optional(),
    description: nonEmptyStringSchema.optional(),
  })
  .strict()
  .refine((value) => value.name !== undefined || value.description !== undefined, {
    message: 'At least one plan metadata field must be provided',
  });

export const UpdatePlatformSystemSubscriptionPlanMetadataBodySchema =
  subscriptionPlanMetadataFieldsSchema satisfies z.ZodType<UpdatePlatformSystemSubscriptionPlanMetadataBody>;

export const UpdatePlatformSystemSubscriptionPlanMetadataRequestSchema =
  subscriptionPlanMetadataFieldsSchema
    .extend({
      planCode: z.enum(planCodeValues),
    })
    .strict()
    .refine((value) => value.name !== undefined || value.description !== undefined, {
      message: 'At least one plan metadata field must be provided',
    }) satisfies z.ZodType<UpdatePlatformSystemSubscriptionPlanMetadataRequest>;

export const UpdatePlatformSystemSubscriptionPlanMetadataResponseSchema = z
  .object({
    plan: PlatformSystemSubscriptionPlanSummarySchema,
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemSubscriptionPlanMetadataResponse>;

const subscriptionPlanActiveStateFieldsSchema = z
  .object({
    isActive: z.boolean(),
  })
  .strict();

export const UpdatePlatformSystemSubscriptionPlanActiveStateBodySchema =
  subscriptionPlanActiveStateFieldsSchema satisfies z.ZodType<UpdatePlatformSystemSubscriptionPlanActiveStateBody>;

export const UpdatePlatformSystemSubscriptionPlanActiveStateRequestSchema =
  subscriptionPlanActiveStateFieldsSchema
    .extend({
      planCode: z.enum(planCodeValues),
    })
    .strict() satisfies z.ZodType<UpdatePlatformSystemSubscriptionPlanActiveStateRequest>;

export const UpdatePlatformSystemSubscriptionPlanActiveStateResponseSchema = z
  .object({
    plan: PlatformSystemSubscriptionPlanSummarySchema,
    mutation: z
      .object({
        kind: z.enum(['activated', 'deactivated', 'unchanged']),
        assignedCompanyCount: z.number().int().min(0),
        revokedCompanySessionsCount: z.number().int().min(0),
        entitlementRevisionBumpCount: z.number().int().min(0),
      })
      .strict(),
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemSubscriptionPlanActiveStateResponse>;

const featureMetadataFieldsSchema = z
  .object({
    description: nonEmptyStringSchema.optional(),
  })
  .strict()
  .refine((value) => value.description !== undefined, {
    message: 'At least one feature metadata field must be provided',
  });

export const UpdatePlatformSystemFeatureMetadataBodySchema =
  featureMetadataFieldsSchema satisfies z.ZodType<UpdatePlatformSystemFeatureMetadataBody>;

export const UpdatePlatformSystemFeatureMetadataRequestSchema = featureMetadataFieldsSchema
  .extend({
    featureKey: nonEmptyStringSchema,
  })
  .strict()
  .refine((value) => value.description !== undefined, {
    message: 'At least one feature metadata field must be provided',
  }) satisfies z.ZodType<UpdatePlatformSystemFeatureMetadataRequest>;

export const UpdatePlatformSystemFeatureMetadataResponseSchema = z
  .object({
    feature: PlatformSystemFeatureSummarySchema,
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemFeatureMetadataResponse>;

const featureActiveStateFieldsSchema = z
  .object({
    isActive: z.boolean(),
  })
  .strict();

export const UpdatePlatformSystemFeatureActiveStateBodySchema =
  featureActiveStateFieldsSchema satisfies z.ZodType<UpdatePlatformSystemFeatureActiveStateBody>;

export const UpdatePlatformSystemFeatureActiveStateRequestSchema = featureActiveStateFieldsSchema
  .extend({
    featureKey: nonEmptyStringSchema,
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemFeatureActiveStateRequest>;

export const UpdatePlatformSystemFeatureActiveStateResponseSchema = z
  .object({
    feature: PlatformSystemFeatureSummarySchema,
    mutation: z
      .object({
        kind: z.enum(['activated', 'deactivated', 'unchanged']),
        affectedCompanyCount: z.number().int().min(0),
        revokedCompanySessionsCount: z.number().int().min(0),
        entitlementRevisionBumpCount: z.number().int().min(0),
      })
      .strict(),
  })
  .strict() satisfies z.ZodType<UpdatePlatformSystemFeatureActiveStateResponse>;

export const MutatePlatformSystemPlanFeatureMappingBodySchema = z
  .object({})
  .strict() satisfies z.ZodType<MutatePlatformSystemPlanFeatureMappingBody>;

export const MutatePlatformSystemPlanFeatureMappingRequestSchema = z
  .object({
    planCode: z.enum(planCodeValues),
    featureKey: nonEmptyStringSchema,
  })
  .strict() satisfies z.ZodType<MutatePlatformSystemPlanFeatureMappingRequest>;

export const MutatePlatformSystemPlanFeatureMappingResponseSchema = z
  .object({
    plan: PlatformSystemSubscriptionPlanSummarySchema,
    mapping: PlatformSystemPlanFeatureMappingSchema,
    mutation: z
      .object({
        kind: z.enum(['added', 'removed', 'unchanged']),
        affectedCompanyCount: z.number().int().min(0),
        revokedCompanySessionsCount: z.number().int().min(0),
      })
      .strict(),
  })
  .strict() satisfies z.ZodType<MutatePlatformSystemPlanFeatureMappingResponse>;

function isFutureIsoDate(value: string): boolean {
  const candidate = new Date(`${value}T00:00:00.000Z`);
  if (Number.isNaN(candidate.getTime())) {
    return false;
  }

  const today = new Date();
  const todayUtc = new Date(
    Date.UTC(today.getUTCFullYear(), today.getUTCMonth(), today.getUTCDate()),
  );
  return candidate.getTime() > todayUtc.getTime();
}
